let {jwt_decode} = require('../jwt.js');
import { store } from '../store'

// export default function auth({ next, to }) {

export default function auth({ next }) {

    // let ltiAuthCookie = window.$cookies.get('ltiProgress');

    try {
        // let credentials = jwt_decode(ltiAuthCookie)

        // let lms_picture = credentials.picture;
        // let lms_user_name = credentials.user_name;
        // let lms_email = credentials.email;
        // let lms_sis_user_id = credentials.sis_user_id;
        // let lms_sis_course_id = credentials.sis_course_id;
        // let lms_given_name = credentials.given_name;
        // let lms_family_name = credentials.family_name;
        // if(this.$store.authenticated){
        if(store.state.authenticated){
            return next();
         }
        else {
             throw new Error("Not authenticated.");
             }


        /*
        console.log(`lms_picture        ${lms_picture}`);
        console.log(`lms_user_name      ${lms_user_name}`);
        console.log(`lms_email          ${lms_email}`);
        console.log(`lms_sis_user_id    ${lms_sis_user_id}`);
        console.log(`lms_sis_course_id  ${lms_sis_course_id}`);
        console.log(`lms_given_name     ${lms_given_name}`);
        console.log(`lms_family_name    ${lms_family_name}`);
        */

        // let ltiProgressToken = jwt_encode(credentials, false, '30d');

        // window.$cookies.set('ltiProgress', ltiProgressToken, '30d', null, null, true, "None");

       // return next();

    } catch (e) {
        console.log(`ERROR ${e}`);
        return next('/requiresLti');
    }

}
